import React from 'react';

// Exact port of legacy `.icon-remove` glyph (blue circle, white x)
const DismissIcon = () => (
  <span className="svg-icon">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
      <g fillRule="evenodd" fill="none">
        <path fill="#0272B6" d="M3.222 18.778c4.296 4.296 11.26 4.296 15.556 0 4.296-4.296 4.296-11.26 0-15.556-4.296-4.296-11.26-4.296-15.556 0-4.296 4.296-4.296 11.26 0 15.556z" />
        <path stroke="#FFF" strokeWidth="2" strokeLinecap="round" d="M15.243 6.757l-8.486 8.486M15.243 15.243L6.757 6.757" />
      </g>
    </svg>
  </span>
);

export default DismissIcon;
